import { styled, typography } from '@pulse-web-ui/theme';

export const AlertTitle = styled.div`
  ${typography.medium16}
  margin-bottom: 4px;
`;
